import {
  axios
} from '@/utils/request'

//合作商充值明细
export function getRechargList(parameter) {
  return axios({
    url: '/Seller/SellerManage/GetUSellerfund_Vue',
    method: 'get',
    params: parameter
  })
}

//优惠券列表
export function getCouponsList(parameter) {
  return axios({
    url: '/Seller/SellerManage/getPageCoupons_Vue',
    method: 'get',
    params: parameter
  })
}

//根据车牌获取列表
export function getOrderBylp(parameter) {
  return axios({
    url: '/Seller/SellerManage/getOrderBylp',
    method: 'get',
    params: parameter
  })
}

//根据手机号获取列表
export function getOrderByPhone(parameter) {
  return axios({
    url: '/Seller/SellerManage/getOrderByPhone',
    method: 'get',
    params: parameter
  })
}



//优惠券派发页面优惠券下拉列表数据
export function getSelectCouponsList(parameter) {
  return axios({
    url: '/Seller/SellerManage/getSelectCouponsList_Vue',
    method: 'get',
    params: parameter
  })
}

//查询优惠券信息
export function getCouponsInfo(parameter) {
  return axios({
    url: '/Seller/SellerManage/GetCouponInfo_Vue',
    method: 'get',
    params: parameter
  })
}

//根据车牌获取停车信息
export function getLicenseplateInfo(parameter) {
  return axios({
    url: '/Seller/SellerManage/getLicenseplateInfo_Vue',
    method: 'get',
    params: parameter
  })
}

//根据手机号获取停车信息
export function getLicenseplateInfoByMobile(parameter) {
  return axios({
    url: '/Seller/SellerManage/getLicenseplateInfoByMobile_Vue',
    method: 'get',
    params: parameter
  })
}

//添加优惠券
export function AddCoupons(parameter) {
  return axios({
    url: '/Seller/SellerManage/AddCoupons_Vue',
    method: 'get',
    params: parameter
  })
}

//模糊查询车牌号
export function getLicenseplateLikeQuery(parameter) {
  return axios({
    url: '/Seller/SellerManage/getLicenseplateLikeQuery_Vue',
    method: 'get',
    params: parameter
  })
}

//模糊查询手机号
export function getLicenseplateLikeQueryByPhone(parameter) {
  return axios({
    url: '/Seller/SellerManage/getLicenseplateLikeQueryByPhone_Vue',
    method: 'get',
    params: parameter
  })
}

//在线充值
export function sellerRecharge(parameter) {
  return axios({
    url: '/Seller/SellerManage/sellerRecharge_Vue',
    method: 'get',
    params: parameter
  })
}

//次卡优惠券列表
export function getSellerNumUcoupons(parameter) {
  return axios({
    url: '/Seller/SellerManage/getSellerNumUcoupons_Vue',
    method: 'get',
    params: parameter
  })
}

//限时优惠券列表
export function getTimeLimitedCoupons(parameter) {
  return axios({
    url: '/Seller/SellerManage/getTimeLimitedCoupons_Vue',
    method: 'get',
    params: parameter
  })
}

//优惠券二维码
export function getCouponQr(parameter) {
  return axios({
    url: '/QRcode/couponQr_Vue',
    method: 'get',
    params: parameter
  })
}

//删除优惠券
export function deletCoupons(parameter) {
  return axios({
    url: '/Seller/SellerManage/DeletCoupons_Vue',
    method: 'get',
    params: parameter
  })
}

//消耗
export function drcQrcode(parameter) {
  return axios({
    url: '/Seller/SellerManage/drcQrcode',
    method: 'get',
    params: parameter
  })
}